export default __webpack_public_path__ + "static/media/sheet.3185e711.webp";